import {Component, OnInit, AfterViewInit} from '@angular/core';

declare var $: any;
declare var Ps: any;

@Component({
  selector: 'app-navigationbar',
  templateUrl: './navigationbar.component.html',
  styleUrls: ['./navigationbar.component.css']
})
export class NavigationbarComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // $(".button-collapse").sideNav();

// Custom scrollbar init
//     var el = document.querySelector('.custom-scrollbar');
//     Ps.initialize(el);
  }


}



// WEBPACK FOOTER //
// ./src/app/navigationbar/navigationbar.component.ts